import { t } from "i18next";
import { useMemo } from "react";
import { ProjectStatus } from "../../autogen/bff-api";

export const useProjectStatuses = () => {
  const projectStatuses: {
    [status in ProjectStatus]: {
      name: string;
      colorScheme: string;
    };
  } = useMemo(
    () => ({
      NotStarted: { name: projectStatusLabel(ProjectStatus.NotStarted, t), colorScheme: "cyan" },
      Ongoing: { name: projectStatusLabel(ProjectStatus.Ongoing, t), colorScheme: "teal" },
      Ended: { name: projectStatusLabel(ProjectStatus.Ended, t), colorScheme: "orange" },
    }),
    []
  );
  return projectStatuses;
};

export const projectStatusLabel = (status: ProjectStatus, t: (key: string) => string): string => {
  switch (status) {
    case ProjectStatus.NotStarted:
      return t("Not started");
    case ProjectStatus.Ongoing:
      return t("Ongoing");
    case ProjectStatus.Ended:
      return t("Ended");
  }
};

export const knownProjectStatuses = (statuses: string | null): string =>
  (statuses ?? "")
    .split(",")
    .filter((status) => Object.values(ProjectStatus).some((known) => known === status))
    .join(",");
